import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationGroundLevelPluginService } from './ground-level.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-ground-level-edit',
    templateUrl: './ground-level-edit.component.html',
    standalone: false
})
export class InstallationGroundLevelEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  levelTypes: any[];

  private sub = new Subscription();

  @ViewChild('levelTypesModal', { static: true }) levelTypesModal: ModalComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationGroundLevelPluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateGroundLevel(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.controls['levelType'].markAsTouched();
  }

  public openLevelTypesSelector() {
    this.openSelector(this.levelTypesModal, this.levelTypes, this.editForm.controls.levelType.value);
  }

  public selectLevelTypesMenu(item: any) {
    const selectedIndex = this.editForm.controls.levelType.value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls.levelType.setValue(selectedIndex);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.levelTypes = this.pluginService.getLevelTypes();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      label: new UntypedFormControl(this.plugin.config.Label ?? ''),
      levelType: new UntypedFormControl(this.plugin.config.LevelType ? parseInt(this.plugin.config.LevelType) : '')
    });
  }
}
